export default "{\n    \"label\": \"Cliente\"\n}\n"